import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';

import Draggable from 'react-draggable';

import { useDispatch } from 'react-redux';
import {
  startDraw,
  stopDraw,
  cleanDraw,
  modifyDraw,
  cleanModifyDraw,
} from '../../redux/actions/draw';

import { innerColor, themeColor } from '../../constants/themes';

const DrawUtil = (props) => {
  const map = props.basemap;
  const visibleDraw = props.visible;
  const setVisibleDraw = props.visibleFunc;

  const dispatch = useDispatch();

  return (
    <Draggable>
      <Card
        sx={{
          position: 'absolute',
          zIndex: 99999,
          display: visibleDraw,
        }}
      >
        <CardHeader
          sx={{
            color: innerColor,
            backgroundColor: themeColor,
          }}
          title="Çizim Araçları"
          titleTypographyProps={{ variant: 'h6' }}
          action={
            <IconButton
              sx={{ backgroundColor: 'grey' }}
              onClick={() => setVisibleDraw('none')}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent
          style={{ display: 'flex', flexDirection: 'column', padding: '1em' }}
        >
          <ButtonGroup
            variant="outlined"
            aria-label="outlined primary button group"
          >
            <Tooltip title="Nokta">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Point'));
                }}
              >
                <i className="fg-multipoint fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Çizgi">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'LineString'));
                }}
              >
                <i className="fg-polyline-pt fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Alan">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Polygon'));
                }}
              >
                <i className="fg-polygon-pt fg-2x"></i>
              </Button>
            </Tooltip>
          </ButtonGroup>
          <ButtonGroup
            variant="outlined"
            aria-label="outlined primary button group"
          >
            <Tooltip title="Çember">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Circle'));
                }}
              >
                <i className="fg-circle-o fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Kare">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Square'));
                }}
              >
                <i className="fg-square-pt fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Dikdörtgen">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Box'));
                }}
              >
                <i className="fg-rectangle-pt fg-2x"></i>
              </Button>
            </Tooltip>
          </ButtonGroup>
          <ButtonGroup
            variant="outlined"
            aria-label="outlined primary button group"
          >
            <Tooltip title="Serbest Çizgi">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'LineString', true));
                }}
              >
                <i className="fg-route fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Serbest Alan">
              <Button
                onClick={() => {
                  dispatch(startDraw(map, 'Polygon', true));
                }}
              >
                <i className="fg-measure fg-2x"></i>
              </Button>
            </Tooltip>
          </ButtonGroup>
        </CardContent>
        <CardActions>
          <ButtonGroup
            size="small"
            variant="contained"
            orientation="vertical"
            fullWidth
          >
            <Button
              onClick={() => {
                dispatch(stopDraw(map));
              }}
            >
              Çizimi Bitir
            </Button>
            <Button
              onClick={() => {
                dispatch(modifyDraw(map));
              }}
            >
              Çizimi Düzenle
            </Button>
            <Button
              onClick={() => {
                dispatch(cleanModifyDraw(map));
              }}
            >
              Çizimi Düzenlemeyi Bitir
            </Button>
            <Button
              onClick={() => {
                dispatch(cleanDraw(map));
              }}
            >
              Çizimi Temizle
            </Button>
          </ButtonGroup>
        </CardActions>
      </Card>
    </Draggable>
  );
};

export default DrawUtil;
